module.exports = __webpack_public_path__ + "static/media/subscription-info-banner.28724075.svg";